import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as Vali from 'helper/validator-helper';
import * as MEnum from './maintenance-enums';

import { Dropdown } from 'components/Dropdown/Dropdown';
import { CheckBoxSingle } from 'components/checkboxes/check-box-single';
import { Input, TextArea } from 'components/ValidationInput';

import './maintenance.scss';
import MaintenanceServices from './services';

export class MaintenanceTaskAdd extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    history: PropTypes.object,
    projectId: PropTypes.string,
    lotList: PropTypes.array,
    onCancel: PropTypes.func,
    maintenanceTaskDetail: PropTypes.object
  }

  constructor(props) {
    super(props);

    this.maintenanceService = new MaintenanceServices(this.props.dispatch);
    this.state = {
      activeStep: 1,
      searchText: '',

      selectedType: MEnum.TASK_TYPE_LIST[0],
      selectedRepeatPeriodType: MEnum.REPEAT_PERIOD_LIST[0],
      selectedRepeatStartType: MEnum.REPEAT_START_LIST[0],
      selectedRepeatEndType: MEnum.REPEAT_END_LIST[0],

      name: '',
      description: '',

      selectedLotSet: new Set(),
      applyToAllLot: true
    };
  }

  componentDidMount() {
    this.maintenanceService.getLotList(this.props.projectId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lotList) {
      this.lotSet = this.getLotSet(nextProps.lotList);
      this.state.selectedLotSet = new Set(this.lotSet);
    }
  }

  // manual events
  onTextInputChange = (inputName, obj) => {
    let hasError = false;

    if (!this.textInputs) {
      this.textInputs = {};
    }

    this.textInputs[inputName] = obj;

    for (let key in this.textInputs) {
      if (this.textInputs[key].error) {
        hasError = true;
        break;
      }
    }

    this.setState({ hasError: hasError });
  }

  onClickLotCheckbox = (e, value,s) => {
    s.checked ? this.state.selectedLotSet.add(value) : this.state.selectedLotSet.delete(value);

    this.setState({
      selectedLotSet: this.state.selectedLotSet,
      applyToAllLot: this.state.selectedLotSet.size === this.lotSet.size
    });
  }

  onClickApplyAllCheckbox = (isChecked) => {
    if (isChecked === true) {
      this.lotSet.forEach(element => {
        this.state.selectedLotSet.add(element);
      });

      this.setState({
        applyToAllLot: true,
        selectedLotSet: this.state.selectedLotSet
      });
    }
    else {
      this.state.selectedLotSet.clear();
      this.setState({
        applyToAllLot: false,
        selectedLotSet: this.state.selectedLotSet
      });
    }
  }

  onClickCreateButton = (e) => {
    e.preventDefault();

    this.maintenanceService.createTask(
      this.props.projectId,
      this.textInputs.name.value,
      this.textInputs.description.value,
      this.state.selectedType.value,
      this.state.selectedRepeatPeriodType.value,
      this.state.selectedRepeatStartType.value,
      this.state.selectedRepeatEndType.value,
      this.state.applyToAllLot,
      this.state.applyToAllLot ? null : this.state.selectedLotSet,
      this.props.onCancel
    );
  }

  // end manual events

  // helpers

  getLotSet = (phaseList) => {
    return phaseList.reduce((result1, phase) => {
      return phase.lots.reduce((result2, lot) => {
        result2.add(lot.id);
        return result2;
      }, result1);
    }, new Set());
  }

  // end helpers

  // render
  renderLotList() {
    return (
      <div className='lot-list'>
        {
          Array.isArray(this.props.lotList) &&
          this.props.lotList.map((plan, index) => {
            let visibleLots = plan.lots
              .map(e => {
                return {
                  id: e.id,
                  label: `${e.name}, ${e.streetAddress}`
                };
              })
              .filter(e => e.label.toLowerCase().includes(this.state.searchText.toLowerCase()));

            if (visibleLots.length === 0) { return null;}

            return (
              <div className='plan-item' key={index}>
                <div className='plan-name'>{plan.name}</div>
                <ul>
                  {
                    visibleLots.map(e => {
                      return (
                        <li key={e.id}>
                          <CheckBoxSingle
                            value={e.id}
                            label={e.label}
                            onChecked={this.onClickLotCheckbox}
                            checked={this.state.selectedLotSet.has(e.id)}
                            className='checkbox-default ckb-lot-pick'
                          />
                        </li>);
                    })
                  }
                </ul>
              </div>
            );
          })
        }
      </div>
    );
  }

  renderRepeatSection(isSelectingRepeat) {
    if (!isSelectingRepeat) {return null; }

    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-md-12'>
            <Dropdown
              name='schedule_period'
              style={{width: '100%'}}
              className='filestring-dropdown'
              value={this.state.selectedRepeatPeriodType}
              options={MEnum.REPEAT_PERIOD_LIST}
              optionLabel='text'
              onChange={(e) => {this.setState({selectedRepeatPeriodType: e.value});}}
            />
          </div>
        </div>
        <div className='row'>
          <div className='col-md-6'>
            <label>Starts<span className='text-danger'> *</span></label>
            <Dropdown
              name='schedule_start'
              style={{width: '100%'}}
              className='filestring-dropdown'
              value={this.state.selectedRepeatStartType}
              options={MEnum.REPEAT_START_LIST}
              optionLabel='text'
              onChange={(e) => {this.setState({selectedRepeatStartType: e.value});}}
            />
          </div>
          <div className='col-md-6'>
            <label>Ends<span className='text-danger'> *</span></label>
            <Dropdown
              name='schedule_end'
              style={{width: '100%'}}
              className='filestring-dropdown'
              value={this.state.selectedRepeatEndType}
              options={MEnum.REPEAT_END_LIST}
              optionLabel='text'
              onChange={(e) => {this.setState({selectedRepeatEndType: e.value});}}
            />
          </div>
        </div>
      </React.Fragment>);
  }

  render() {
    return (
      <React.Fragment>
        <div className='step-wrapper'>
          <div className='step'>
            <div
              className={`step-number ${this.state.activeStep === 1 ? 'active' : ''}`}
              onClick={() => this.setState({activeStep: 1})}>1</div>
            <span className='step-header'>Name & Recurring pattern</span>
          </div>
          {
            <div style={{ display: this.state.activeStep === 1 ? '' : 'none' }}>
              <div className='form-group'>
                <label htmlFor='name'>Name<span className='text-danger'> *</span></label>
                <Input
                  type='text'
                  name='name'
                  onChange={v => this.onTextInputChange('name', v)}
                  validators={[Vali.required]}
                />
              </div>
              <div className='form-group'>
                <label htmlFor='description'>Description</label>
                <TextArea
                  name='description'
                  rows={5}
                  onChange={v => this.onTextInputChange('description', v)}
                />
              </div>
              <div className='form-group'>
                <div className='row'>
                  <div className='col-md-3'>
                    <Dropdown
                      name='schedule_month'
                      style={{width: '100%'}}
                      className='filestring-dropdown'
                      optionLabel='text'
                      options={MEnum.TASK_TYPE_LIST}
                      value={this.state.selectedType}
                      onChange={(e) => {this.setState({selectedType: e.value});}}
                    />
                  </div>
                  <div className='col-md-9'>
                    {this.renderRepeatSection(this.state.selectedType.value === 0)}
                  </div>
                </div>
                <button type='button' className='btn btn-primary btn-siteone' onClick={() => this.setState({activeStep: 2})}>Continue</button>
              </div>
            </div>
          }
          {
            <div className='step'>
              <div
                className={`step-number ${this.state.activeStep === 2 ? 'active' : ''}`}
                onClick={() => this.setState({activeStep: 2})}>2</div>
              <span className='step-header'>Apply to the whole project or limit to some lots </span>
            </div>
          }
          {
            this.state.activeStep === 1 &&
            <div style={{marginLeft: 3}}>Select lots to apply this maintenance task (Optional)</div>
          }
          {
            this.state.activeStep === 2 &&
            <React.Fragment>
              <CheckBoxSingle
                name='apply_all'
                ref='isAppliedAll'
                className='checkbox-default'
                style={{margin: 0, bottom: 10, textOverflow: 'ellipsis', overflow: 'hidden'}}
                label='Apply to this maintenance schedule to the whole project'
                checked={this.state.applyToAllLot}
                onChecked={(e,d,s) => this.onClickApplyAllCheckbox(s.checked)}
              />
              {
                this.state.activeStep === 2 &&
                <div className='row'>
                  <div className='col-md-6'>
                    <div style={{margin: '10px 0'}}>
                      <b>Pick lots to apply this maintenance schedule</b>
                    </div>
                    <div className='input-group' style={{margin: '10px 0'}}>
                      <input
                        type='text'
                        className='form-control'
                        placeholder='Lot# / Street address'
                        value={this.state.searchText}
                        onChange={e => this.setState({searchText: e.target.value})}
                        onKeyPress={e => { if (e.key === 'Enter') { this.onSearch(); }}}
                      />
                      <span className='input-group-btn'>
                        <button
                          className='btn btn-secondary'
                          style={{ padding: '4px 10px', fontSize: 16, backgroundColor: '#ececec', border: '0.5px solid #d8d8d8', height: 40 }}
                        >
                          <span className='fa fa-search' />
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              }
              {
                this.renderLotList(!this.state.applyToAllLot)
              }
            </React.Fragment>
          }
        </div>
        {
          <div style={{marginTop: 20}}>
            <div className='col-md-12 col-xs-12'>
              <span
                className='btn btn-siteone-default'
                onClick={this.props.onCancel}>Cancel</span>
              <button
                className='btn btn-primary btn-siteone'
                disabled={this.state.hasError ? 'disabled' : null}
                onClick={(e) => this.onClickCreateButton(e)}>Create</button>
            </div>
          </div>
        }
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lotList: state.ProjectStore.LotsInProject
  };
};

export default connect(mapStateToProps)(MaintenanceTaskAdd);



// WEBPACK FOOTER //
// ./src/Projects/Components/Maintenance/task-general-add.js